export default {
      id: "icon-linkedin-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-linkedin",
      toString: function () {
        return this.url;
      }
    }